import {
  Box,
  Button,
  Checkbox,
  FileInput,
  Group,
  LoadingOverlay,
  Popover,
  Select,
  Text,
  TextInput,
  Textarea,
  rem,
} from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconFileCv, IconX } from "@tabler/icons-react";
import { useEffect, useState, useCallback } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import {
  editCollection,
  getDetailCollection,
  getListCollection,
} from "../../../api/ApiCollection";
import QuillEditor from "../../../common/QuillEditor";
import { CategorySpecialModel } from "../../../model/CategorySpecial";
import ImageShow from "../../../_base/component/_image";
import { uploadFile } from "../../../api/ApiProduct";
import TinyMCEEditor from "../../../common/Tinymce/TinyMCEEditor";

const CreateView = ({ id, onSearch }: { id: number; onSearch: any }) => {
  const entity = {
    id: 0,
    url: "", 
    urlHash: "",
    isParent: 0,
    parentId: 0,
    childListId: "",
    catPath: "",
    iconUrl: null,
    storeCatId: 0,
    name: "",
    indexKey: "",
    nameSearch: "",
    queryCondition: null,
    productQueryCondition: null,
    description: null,
    productCount: 0,
    dayToReset: 0,
    ordering: 0,
    homePage: "",
    status: "",
    visit: 0,
    creationDate: "",
    createdBy: "",
    lastUpdateDate: null,
    lastUpdatedBy: null,
    metaTitle: null,
    metaKeyword: null,
    metaDescription: null,
    isSyncStock: "",
    isSyncPrice: "",
    bannerUrl: null,
    seeMoreUrl: null,
  };
  // const handleChangeDataContent = (content: string | null) => {
  //   let modifiedString = content?.replace(
  //     /src="\/media/g,
  //     'src="https://hanoicomputercdn.com/media'
  //   );
  //   return modifiedString ? modifiedString : "";
  // };
  const handleChangeDataContent = (content: string | null) => {
    if (!content) return "";

    // Nếu đã có domain thì giữ nguyên
    let modifiedString = content.replace(
      /src=(['"])(https:\/\/hanoicomputercdn\.com\/[^\s'"]+)\1/gi,
      (match) => match
    );

    // Thêm domain cho các đường dẫn bắt đầu bằng /media, ../media, ./media, media/
    modifiedString = modifiedString.replace(
      /src=(['"])(\/|\.\.\/|\.\/)?media\/([^\s'"]+)\1/gi,
      'src="https://hanoicomputercdn.com/media/$3"'
    );

    // Thêm domain cho các đường dẫn bắt đầu bằng /lib, /uploads, /images, /static, hoặc không có dấu / ở đầu
    modifiedString = modifiedString.replace(
      /src=(['"])(\/|\.\.\/|\.\/)?(lib|uploads|images|static)\/([^\s'"]+)\1/gi,
      'src="https://hanoicomputercdn.com/$3/$4"'
    );

    return modifiedString;
  };
  const handleCreateCollection = async (dataSubmit: CategorySpecialModel) => {
    open();
    await editCollection({
      ...dataSubmit,
      parentId:
        dataSubmit.parentId !== null
          ? parseInt(dataSubmit.parentId.toString())
          : 0,

      description: shortDescription,
    });
    close();
    modals.closeAll();
    onSearch();
  };
  const [popoverOpened, setPopoverOpened] = useState(false);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [value, setValue] = useState();
  const [dataCollection, setDataCollection] = useState<CategorySpecialModel[]>(
    []
  );
  const [dataOptionCollection, setDataOptionCollection] = useState<any[]>([]);
  const [shortDescription, setShortDescription] = useState(""); // Mô tả dài
  // console.log("shortDescriptionnnn", shortDescription);
  const form = useForm<CategorySpecialModel>({
    initialValues: {
      ...entity,
    },
    validate: {
      name: isNotEmpty("Chưa nhập tên bộ sưu tập"),
      metaTitle: isNotEmpty("Chưa nhập tiêu đề meta"),
      metaKeyword: isNotEmpty("Chưa nhập từ khóa meta"),
      metaDescription: isNotEmpty("Chưa nhập mô tả meta"),
      status: isNotEmpty("Chưa chọn trạng thái !"),
      url: (value: string | null | undefined) => {
        return !value || /^\s*$/.test(value)
          ? "Link chưa nhập"
          : // : !/^\/[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)
            // ? "Giá trị của Link phải theo định dạng /aa-bb-cc"
            undefined;
      },
    },
  });
  const loadDataCollection = async () => {
    setDataCollection([]);
    const data = await getListCollection("Active=true&Skip=0&Take=1000");
    setDataCollection(data?.data);
  };
  const callApiGetData = useCallback(async () => {
    open();
    const callApi = await getDetailCollection(`id=${id}`);
    if (!isNullOrUndefined(callApi) && !isNullOrUndefined(callApi?.data)) {
      const dataApi = callApi?.data;
      if (dataApi != null && !isNullOrUndefined(dataApi)) {
        // Convert parentId to string to match with Select options
        const formData = {
          ...dataApi,
          parentId: dataApi.parentId ? dataApi.parentId.toString() : null,
        };
        form.setValues(formData);
      } else {
        NotificationExtension.Fails("Dữ liệu không tồn tại");
        modals.closeAll();
      }
      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  }, [id, open, close, form]);
  // Hàm để đếm số từ
  const countWords = (text: string) => {
    const words = text.split(/\s+/).filter((word: any) => word !== "");
    return words.length;
  };

  // Hàm để đếm số kí tự
  const countCharacters = (text: string) => {
    return text.length;
  };

  console.log("form.getValue()", form.getValues());
  console.log("form.errors;", form.errors);
  useEffect(() => {
    loadDataCollection();
  }, []);

  useEffect(() => {
    if (id && dataCollection.length > 0) {
      callApiGetData();
    }
  }, [id, dataCollection]);
  useEffect(() => {
    setDataOptionCollection(
      dataCollection
        .filter((option) => option && option.id && option.name) // xóa những giá trị bị nul hoặc undefined
        .map((option) => ({
          value: option.id.toString(),
          label: option.name || "Không có tiêu đề",
        }))
    );
  }, [dataCollection]);

  const icon = (
    <IconFileCv style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );

  const handleChangeImage = async (file: File | null) => {
    console.log("file", file);

    if (!file) {
      // Nếu user xóa file (clear)
      form.setFieldValue("bannerUrl", null);
      return;
    }

    try {
      open(); // Hiện loading

      // Upload file
      const response = await uploadFile([file]);

      if (
        response &&
        response.success &&
        response.data &&
        response.data.length > 0
      ) {
        const uploadedUrl = response.data[0]?.url;
        form.setFieldValue("bannerUrl", uploadedUrl);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      NotificationExtension.Fails("Upload ảnh thất bại!");
    } finally {
      close(); // Tắt loading
    }
  };

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={1000}
        maw={1000}
        mx="auto"
        onSubmit={form.onSubmit(async (values: CategorySpecialModel) => {
          await handleCreateCollection(values);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Tên bộ sưu tập"}
            placeholder={"Nhập tên bộ sưu tập"}
            withAsterisk
            mt="md"
            type="text"
            key={form.key("name")}
            {...form.getInputProps("name")}
          />
          <TextInput
            label={"Link"}
            placeholder={"Nhập link"}
            withAsterisk
            mt="md"
            type="text"
            key={form.key("url")}
            {...form.getInputProps("url")}
          />
        </Group>
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Select
            label={"Trạng thái"}
            placeholder={"Chọn trạng thái"}
            withAsterisk
            mt="md"
            data={[
              { value: "N", label: "Ẩn" },
              { value: "A", label: "Hiện" },
            ]}
            key={form.key("status")}
            {...form.getInputProps("status")}
          />
          <Select
            label={"Bộ sưu tập cha"}
            placeholder={"Chọn bộ sưu tập cha"}
            clearable
            mt="md"
            data={dataOptionCollection}
            key={form.key("parentId")}
            nothingFoundMessage="Không có dữ liệu"
            {...form.getInputProps("parentId")}
          />
        </Group>
        <Group grow wrap="nowrap" gap={"lg"}>
          <FileInput
            leftSection={icon}
            label={"Banner cho landing page"}
            placeholder={"Chọn ảnh"}
            accept="image/png,image/jpeg"
            clearable
            w={"50%"}
            mt="md"
            mb="md"
            key={form.key("bannerUrl")}
            {...form.getInputProps("bannerUrl")}
            onChange={handleChangeImage}
          />
          <div style={{ width: "50%" }}>
            {form.getValues().bannerUrl && (
              <>
                <ImageShow
                  h={200}
                  w={300}
                  img={form.getValues().bannerUrl?.toString() ?? ""}
                />
              </>
            )}
          </div>
        </Group>
        <Group grow wrap="nowrap" gap={"lg"}>
          <TextInput
            label={'Link "Xem thêm" cho Landing page'}
            placeholder={"Nhập link seeMoreUrl"}
            mt="sm"
            type="text"
            key={form.key("seeMoreUrl")}
            {...form.getInputProps("seeMoreUrl")}
          />
        </Group>
        <Group grow wrap="nowrap" mt="lg" gap={"sm"} mb="md">
          <Checkbox
            label="Không đồng bộ giá"
            name="isSyncPrice"
            checked={form.getValues().isSyncPrice === "Y"}
            key={form.key("isSyncPrice")}
            onChange={(e) =>
              form.setFieldValue(
                "isSyncPrice",
                e.currentTarget.checked ? "Y" : "N"
              )
            }
          />
          <Checkbox
            label="Không đồng bộ tồn kho"
            name="isSyncStock"
            checked={form.getValues().isSyncStock === "Y"}
            key={form.key("isSyncStock")}
            onChange={(e) =>
              form.setFieldValue(
                "isSyncStock",
                e.currentTarget.checked ? "Y" : "N"
              )
            }
          />
        </Group>

        <Text size="sm" mt="sm" fw={500}>
          Nội dung
        </Text>
        {/* <QuillEditor
          toolbarId="t1"
          setValue={setValue}
          onChangeValue={(html: string) =>
            (form.values.description = handleChangeDataContent(html))
          }
          description={handleChangeDataContent(form.values.description)}
        /> */}
        <TinyMCEEditor
          height="600"
          contentText={handleChangeDataContent(
            form.getValues().description || ""
          )}
          nameOnchange="description"
          setValue={setShortDescription}
        />
        <Text size="sm" mt="sm" fw={700}>
          Dùng cho SEO
        </Text>
        <Group grow wrap="wrap" gap={"lg"}>
          <TextInput
            label={"Tiêu đề Meta"}
            placeholder={"Nhập tiêu đề meta"}
            withAsterisk
            name="metaTitle"
            key={form.key("metaTitle")}
            {...form.getInputProps("metaTitle")}
            onChange={(e) => {
              form.setFieldValue("metaTitle", e.target.value);
            }}
          />
          <p style={{ fontSize: 12.25, paddingTop: 20 }}>
            Số từ:{" "}
            <span style={{ fontWeight: 500 }}>
              {countWords(form.getValues().metaTitle?.toString() || "")}{" "}
            </span>
            , Số kí tự:{" "}
            <span style={{ fontWeight: 500 }}>
              {countCharacters(form.getValues().metaTitle?.toString() || "")}
            </span>
          </p>
        </Group>

        <Group grow wrap="wrap" gap={"lg"}>
          <TextInput
            label={"Từ khóa Meta"}
            placeholder={"Nhập từ khóa meta"}
            withAsterisk
            name="metaKeyword"
            key={form.key("metaKeyword")}
            {...form.getInputProps("metaKeyword")}
            onChange={(e) => form.setFieldValue("metaKeyword", e.target.value)}
          />
          <p style={{ fontSize: 12.25, paddingTop: 20 }}>
            Số từ:{" "}
            <span style={{ fontWeight: 500 }}>
              {countWords(form.getValues().metaKeyword?.toString() || "")}{" "}
            </span>
            , Số kí tự:{" "}
            <span style={{ fontWeight: 500 }}>
              {countCharacters(form.getValues().metaKeyword?.toString() || "")}{" "}
            </span>
          </p>
        </Group>

        <Textarea
          label={"Mô tả Meta"}
          placeholder={"Nhập mô tả meta"}
          withAsterisk
          name="metaDescription"
          key={form.key("metaDescription")}
          {...form.getInputProps("metaDescription")}
          onChange={(e) =>
            form.setFieldValue("metaDescription", e.target.value)
          }
        />
        <p style={{ fontSize: 12.25 }}>
          Số từ:{" "}
          <span style={{ fontWeight: 500 }}>
            {countWords(form.getValues().metaDescription?.toString() || "")}{" "}
          </span>
          , Số kí tự:{" "}
          <span style={{ fontWeight: 500 }}>
            {countCharacters(
              form.getValues().metaDescription?.toString() || ""
            )}{" "}
          </span>
          <span style={{ fontWeight: 500 }}> (Khuyến nghị: 160 ký tự)</span>
        </p>
        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <Popover
            width={300}
            position="top"
            withArrow
            shadow="md"
            opened={popoverOpened}
            onChange={setPopoverOpened}
          >
            <Popover.Target>
              <Button
                color="red"
                style={{ marginLeft: 10 }}
                onClick={() => setPopoverOpened(true)}
                leftSection={<IconX size={18} />}
              >
                Đóng
              </Button>
            </Popover.Target>
            <Popover.Dropdown>
              <Text>Bạn có chắc chắn muốn đóng không?</Text>
              <Group grow mt="lg">
                <Button
                  color="red"
                  leftSection={<IconCheck size={18} />}
                  onClick={() => {
                    modals.closeAll();
                  }}
                >
                  Đóng
                </Button>
                <Button
                  variant="outline"
                  color="gray"
                  leftSection={<IconX size={18} />}
                  onClick={() => setPopoverOpened(false)}
                >
                  Hủy
                </Button>
              </Group>
            </Popover.Dropdown>
          </Popover>
        </Group>
      </Box>
    </>
  );
};

export default CreateView;
